import React from "react";

const testimonials = [
  { text: "Être tuteur GoNextMaker m’a permis de guider des jeunes brillants, mais aussi d’apprendre énormément d’eux.", author: "— Aïssatou, mentor en électronique" },
  { text: "J’ai animé un atelier sur la programmation et j’ai été impressionné par l’énergie et la créativité des jeunes.", author: "— David, tuteur en coding" },
];

const Testimonials = () => (
  <section className="w-full bg-white py-12 px-6">
    <div className="max-w-4xl mx-auto text-center">
      <h3 className="text-title font-bold text-dark-1 mb-8">Témoignages</h3>
      <div className="space-y-6">
        {testimonials.map((t, i) => (
          <blockquote key={i} className="p-6 bg-light-5 rounded-2xl shadow">
            <p className="italic text-dark-3">“{t.text}”</p>
            <footer className="mt-2 text-blue-1 font-semibold">{t.author}</footer>
          </blockquote>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
